<script setup>
import Header from '@/components/mainHeader.vue';
import Footer from '@/components/mainFooter.vue';
</script>

<template>
  <div id="app">
    <Header />
    <router-view />
    <!-- <router-view v-slot="{ Component, route }">
      <transition name="route" mode="out-in">
        <component :is="Component"></component>
      </transition>
    </router-view> -->
    <Footer />
  </div>
</template>

<style lang="scss">
@use './assets/scss/main.scss';
.route-enter-from {
  opacity: 0;
  transform: translate(100px);
}
.route-enter-active {
  transition: all 0.3s ease-out;
}
.route-leave-to {
  opacity: 0;
  transform: translate(-100px);
}
.route-leave-active {
  transition: all 0.3s ease-in;
}
</style>

<!-- testign transitions but recieved css babel or 'salt' errors -->

<!-- <script setup>
import Header from '@/components/mainHeader.vue';
import Footer from '@/components/mainFooter.vue';
</script> -->

<!-- <template>
  <div id="app">
    <Header />
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <Footer />
  </div>
</template> -->

<!-- <template>
  <div id="app">
    <Header />
    <router-view v-slot="{ Component }">
      <transition name="fade">
        <component :is="Component" />
      </transition>
    </router-view>
    <Footer />
  </div>
</template>

<style>
@import './assets/scss/main.scss';
.route-enter-from {
  opacity: 0;
  transform: translate(100px);
}
.route-enter-active {
  transition: all 0.3s ease-out;
}
.route-leave-to {
  opacity: 0;
  transform: translate(-100px);
}
.route-leave-active {
  transition: all 0.3s ease-in;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style> -->
<!-- <style lang="scss">
@import './assets/scss/main.scss';
.route-enter-from {
  opacity: 0;
  transform: translate(100px);
}
.route-enter-active {
  transition: all 0.3s ease-out;
}
.route-leave-to {
  opacity: 0;
  transform: translate(-100px);
}
.route-leave-active {
  transition: all 0.3s ease-in;
}
</style> -->
